module.exports = __webpack_public_path__ + "static/media/app-store.2610de7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/App/components/imgs/app-store.svg
// module id = 806
// module chunks = 0